"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var CfgPayoutListCtl = /** @class */ (function (_super) {
    __extends(CfgPayoutListCtl, _super);
    function CfgPayoutListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_css_classname = UIUtils_1.UIUtils.IProp2Str(function (o) { o.css_classname; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_is_deprecated = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_deprecated; });
        _this.dk_outer_provider_identity = UIUtils_1.UIUtils.IProp2Str(function (o) { o.outer_provider_identity; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    CfgPayoutListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0,
            currency_filter: []
        };
    };
    CfgPayoutListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    CfgPayoutListCtl.prototype.LoadData = function (onDone) {
        var _this = this;
        webAApi_1.ListPayoutsGet.exec({}, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            //
            _this.DATA.currency_filter = [];
            var currency_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                if (!currency_filter_map.get(resp.list[i].app_currency_title)) {
                    _this.DATA.currency_filter.push({ text: resp.list[i].app_currency_title, value: resp.list[i].app_currency_title });
                    currency_filter_map.set(resp.list[i].app_currency_title, resp.list[i].app_currency_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    is_deprecated: resp.list[i].is_deprecated,
                    css_classname: resp.list[i].css_classname,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    title: resp.list[i].title,
                    outer_provider_identity: resp.list[i].outer_provider_identity,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgPayoutListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPayout.exec({
            data: {
                title: data.title,
                css_classname: data.css_classname,
                is_deprecated: data.is_deprecated,
                app_currency_id: data.app_currency_id,
                outer_provider_identity: data.outer_provider_identity
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_added_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                title: data.title,
                css_classname: data.css_classname,
                is_deprecated: data.is_deprecated,
                outer_provider_identity: data.outer_provider_identity,
                app_currency_id: data.app_currency_id,
                app_currency_title: resp.app_currency_title
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    CfgPayoutListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPayout.exec({
                data: {
                    app_payout_id: data.key,
                    title: data.title,
                    css_classname: data.css_classname,
                    is_deprecated: data.is_deprecated,
                    app_currency_id: data.app_currency_id,
                    outer_provider_identity: data.outer_provider_identity
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.css_classname = data.css_classname;
                _tmp.is_deprecated = data.is_deprecated;
                _tmp.app_currency_id = data.app_currency_id;
                _tmp.app_currency_title = resp.app_currency_title;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.outer_provider_identity = data.outer_provider_identity;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgPayoutListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    CfgPayoutListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePayout.exec({ data: { app_payout_id: key } }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    CfgPayoutListCtl.prototype.SetIsDeprecated = function (key, IsDeprecated, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPayoutIsDeprecated.exec({ data: { app_payout_id: key, is_deprecated: IsDeprecated } }, function (resp) {
                _tmp.is_deprecated = IsDeprecated;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return CfgPayoutListCtl;
}(BaseController_1.BaseController));
exports.CfgPayoutListCtl = CfgPayoutListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_payout/ctl/CfgPayoutListCtl.ts
// module id = 986
// module chunks = 0